import { forwardRef, useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getSrcSet, getSizes, getResponsiveImage, buildCmsUrl } from "../../utils/imageHelper";



/*eslint-disable */

declare const window: any;

interface VersionesVehiculosComponentProps {
  versiones: any;
}

const VersionesVehiculosComponent = forwardRef<
  HTMLDivElement,
  VersionesVehiculosComponentProps
>(({ versiones }, ref) => {
  const scrollContainerRef: any = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePrev = () => {
    scrollContainerRef.current.scrollBy({
      left: windowWidth < 768 ? -310 : -394,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    scrollContainerRef.current.scrollBy({
      left: windowWidth < 768 ? 310 : 394,
      behavior: "smooth",
    });
  };

  return (
    <div className="versiones-vehiculos-detail-component" ref={ref}>
      {/* H2 - Título principal de la sección */}
      <h2 className="title-versiones-vehiculos-detail-component">
        Encuentra el Hyundai que mejor se adapte a ti
      </h2>
      
      <div
        className="btn-carrousel-versiones-vehiculos-detail-component prev"
        onClick={handlePrev}
      >
        <img src="/assets/01_Home/Icon_Left.svg" alt="Desplazar a la izquierda" width="40" height="40" />
      </div>
      
      <div
        className="carrousel-versiones-vehiculos-detail-component"
        ref={scrollContainerRef}
      >
        {versiones?.version?.sort((a:any, b:any) => a.order - b.order).map((item: any, index: any) => (
          <div
            key={index}
            className={`item-versiones-vehiculos-detail-component`}
          >
            {/* H3 - Título de la versión */}
            <h3 className={`title-item-versiones-vehiculos-detail-component`}>
              {item.title}
            </h3>
            
            <div
              className={`asset-item-versiones-vehiculos-detail-component`}
              style={{ backgroundImage: `URL(${getResponsiveImage(item?.image?.url || '').desktop})` }}
            ></div>

            
            {/* H4 - Subtítulo de precio */}
            <h4 className={`subtitle-precio-item-versiones-vehiculos-detail-component`}>
              Disponible desde
            </h4>
            
            {/* H5 - Precio */}
            <h5 className={`precio-item-versiones-vehiculos-detail-component`}>
              {item.price}
            </h5>
            
            <div className="separador-item-versiones-vehiculos-detail-component"></div>
            
            <div className={`colores-item-versiones-vehiculos-detail-component`}>
              {item?.colors?.map((color: any, index: number) => (
                <div
                  key={index}
                  className={`color-item-versiones-vehiculos-detail-component`}
                  style={{ backgroundColor: color?.color_hexa }}
                  aria-label={`Color ${color?.name || "disponible"}`}
                ></div>
              ))}
            </div>
            
            <div className={`opciones-item-versiones-vehiculos-detail-component`}>
              <img 
                src={buildCmsUrl(item?.icon1?.url)} 
                srcSet={getSrcSet(item?.icon1?.url || '')}
                sizes={getSizes('30px')}
                alt={item?.text1 || "Ícono de opción 1"} 
                width="30"
                height="30"
              />
              <span>{item?.text1}</span>
            </div>

            
            <div className={`opciones-item-versiones-vehiculos-detail-component`}>
              <img 
                src={buildCmsUrl(item?.icon2?.url)} 
                srcSet={getSrcSet(item?.icon2?.url || '')}
                sizes={getSizes('30px')}
                alt={item?.text2 || "Ícono de opción 2"} 
                width="30"
                height="30"
              />
              <span>{item?.text2}</span>
            </div>

            
            <div className={`opciones-item-versiones-vehiculos-detail-component`}>
              <img 
                src={buildCmsUrl(item?.icon3?.url)} 
                srcSet={getSrcSet(item?.icon3?.url || '')}
                sizes={getSizes('30px')}
                alt={item?.text3 || "Ícono de opción 3"} 
                width="30"
                height="30"
              />
              <span>{item?.text3}</span>
            </div>

            
            <Link
              to={item?.url_quote !== null && item?.url_quote !== undefined ? `/vehiculos/${item?.url_quote}` : `#`}
              className="mas-item-versiones-vehiculos-detail-component"
            >
              Cotiza
            </Link>
            
            {item?.url_reserve ? (
              <a
                href={`${item?.url_reserve}`}
                className="cotiza-item-versiones-vehiculos-detail-component"
              >
                Reserva en línea
              </a>
            ) : null}
          </div>
        ))}
      </div>
      
      <div
        className="btn-carrousel-versiones-vehiculos-detail-component next"
        onClick={handleNext}
      >
        <img src="/assets/01_Home/Icon_Right.svg" alt="Desplazar a la derecha" width="40" height="40" />
      </div>
    </div>
  );
});

export default VersionesVehiculosComponent;